module.exports = "https://la-static.vkplay.ru/promo/newstart/img/hawkeye.ca937651.png";